import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RoleRoutingModule } from './role-routing.module';
import { RoleComponent } from './role.component';
import { DxDataGridModule, DxButtonModule, DxPopupModule, DxDropDownButtonModule, DxRangeSelectorModule, DxTextAreaModule, DxTextBoxModule, DxValidationSummaryModule, DxValidatorModule } from 'devextreme-angular';
import { DevEpressCommonModule } from 'src/app/dev-epress-common.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';


@NgModule({
  declarations: [RoleComponent],
  imports: [
    CommonModule,
    RoleRoutingModule, DxDataGridModule,
    DevEpressCommonModule, DxButtonModule, DxPopupModule,
    DxDropDownButtonModule,
    DxTextAreaModule, DxRangeSelectorModule, DxTextBoxModule, FormsModule, ReactiveFormsModule,
    DxValidatorModule,
    DxValidationSummaryModule 
  ]
})
export class RoleModule { }
